module.exports = __webpack_public_path__ + "static/media/medal.91663d08.svg";